module.exports = __webpack_public_path__ + "media/images/athletes/1656-0d04a9674bc1eee3788fa5ebe586421f.png";